/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import linearGradient from "assets/theme/functions/linearGradient";
import { CssBaseline, ThemeProvider } from "@mui/material";

// Material Dashboard 2 PRO React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// Material Dashboard 2 PRO React Dark Mode themes
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";
import CoverLayout from "./login";
// Authentication layout components
// import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/lh/site-header-bg-2.jpg";
import PropTypes from "prop-types";
import { GoogleLogin } from "@react-oauth/google";

function Login({ onLogin }) {

  const [darkMode, setDarkMode] = useState(true);
  const [tc, setTCStatus] = useState(false);

  const setTC = () => {
    setTCStatus(!tc);
  }

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />

      <CoverLayout image={bgImage}>
        <Card>
          <MDBox
            variant="gradient"
            bgColor="dark"
            borderRadius="lg"
            coloredShadow="secondary"
            mx={2}
            mt={-3}
            p={3}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
              ලක් හඳහන
            </MDTypography>
            <MDTypography variant="h5" fontWeight="medium" color="white" mt={1}>
              සිංහල ජ්යෝතිෂ මෘදුකාංගය <br /> Sinhala Astrology Software
            </MDTypography>

          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form">
              <MDBox display="flex" alignItems="center" ml={0}>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;මම &nbsp;
                </MDTypography>
                <MDTypography
                  component="a"
                  href="#"
                  variant="button"
                  fontWeight="bold"
                  color="info"
                  textGradient
                  onClick={openTC}
                >
                  නියමයන් සහ කොන්දේසි වලට එකඟ වෙමි
                </MDTypography>
              </MDBox>
              <MDBox display="flex" alignItems="center" ml={-1}>
                {tc && <Checkbox checked={true} disabled onClick={setTC} />}
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1, PaddingLeft:4 }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;I agree the&nbsp;
                </MDTypography>
                <MDTypography
                  component="a"
                  href="#"
                  variant="button"
                  fontWeight="bold"
                  color="info"
                  textGradient
                  onClick={openTC}
                >
                  Terms and Conditions
                </MDTypography>

              </MDBox>
              <MDBox mt={4} mb={1}>

                {!tc && <MDButton onClick={() => {
                  setTC(true);
                  //onLogin()
                }} variant="gradient" color="primary" fullWidth>
                  එකඟ වෙමි | I Agree
                </MDButton>}
                {tc &&
                  <>
                    <MDBox sx={{
                      display: { xs: "flex" },
                      justifyContent: { xs: "center" },
                      alignItems: { xs: "center" }
                    }}>
                      <MDTypography display="block" variant="h6" color="white" my={1}>
                        ඔබගේ ගූගල් ගිණුම සමඟ ඇතුල් වන්න <br />  Log in with your Google account
                      </MDTypography>
                    </MDBox>
                    <MDBox sx={{
                      display: { xs: "flex" },
                      justifyContent: { xs: "center" },
                      alignItems: { xs: "center" }
                    }}>

                      <GoogleLogin disabled={!tc}
                        onSuccess={credentialResponse => {
                          //console.log('Login Success', credentialResponse);
                          onLogin(credentialResponse);
                        }}
                        onError={() => {
                          console.log('Login Failed');
                        }}
                        theme="outline"
                        logo_alignment="left"
                        accessType="offline" // Request refresh token

                      /></MDBox>
                  </>}
              </MDBox>

            </MDBox>
          </MDBox>
        </Card>
      </CoverLayout>
    </ThemeProvider>
  );
}

export default Login;
function openTC() {
  return window.open(`${process.env.PUBLIC_URL}/tandc.html`, '_blank');
}

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

